import React from 'react'
import { useTranslation } from 'react-i18next'
import AnalyticSeriesChart, {
    AnalyticSeriesData,
} from '../../../shared/AnalyticSeriesChart'

interface VMSDurationChartProps {
    data?: AnalyticSeriesData
}

// VMS transcoding duration (hours). Single-metric time series from the
// margarita-backed endpoint (type=/vms_transcoding_duration).
const VMSDurationChart: React.FC<VMSDurationChartProps> = ({ data }) => {
    const { t } = useTranslation()
    return (
        <AnalyticSeriesChart
            data={data}
            title={t('services.vms-transcoding-duration')}
            unit="hours"
            color="#10b981"
            variant="area"
            totalLabel="Total Hours"
            emptyText="No VMS duration data available for the selected period"
        />
    )
}

export default VMSDurationChart
